import React from 'react'

import { SessionContext } from './context'
import { ISession } from './types'
import { useProvideSession } from './useSession'

export type TSessionProviderProps = {
  initialValue: ISession
  children: React.ReactNode
}

export function SessionProvider({ initialValue, children }: TSessionProviderProps) {
  const session = useProvideSession(initialValue)

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>
}
